import React, { useRef, useState } from "react";
import { Card, Row, Col, Avatar, Typography, Image } from "antd";
import { getCardStyle } from "../../../../utils/getCardStyle";
import { getCardBackgroundColor } from "../detalleOrden/getCardBackgroundColor";
import { EyeOutlined } from "@ant-design/icons";
import "../../index.css";
import ModalStock from "../../../../components/modalStock/ModalStock";
import { useAppVersionContext } from "../../../../AppVersionContext";

const { Text } = Typography;

const ArticuloCard = ({
  item,
  darkMode,
  ordenActiva,
  onOpenCantidadModal,
  isHighlighted,
  tiposma,
  ubicacionResaltadaId,
}) => {
  const holdTimeoutRef = useRef(null);
  const { usaModoLote } = useAppVersionContext();
  const [modalStockVisible, setModalStockVisible] = useState(false);
  const [skuParaModal, setSkuParaModal] = useState(null);

  const isResaltado = item?.ubicacion_id === ubicacionResaltadaId;

  return (
    <>
      <Card
        className={isHighlighted ? "highlight-card" : ""}
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          backgroundColor: getCardBackgroundColor(
            item.confirmada,
            item.cantidad,
          ),
          transition: "background-color 0.3s ease",
          border: isResaltado ? "2px solid #1890ff" : undefined,
        }}
      >
        {/* FILA 1 */}
        <Row justify="space-between" align="middle">
          <Col>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Text strong style={{ fontSize: 20, color: "#000" }}>
                {item.articulologico_ctdpar > 1
                  ? `${item.articulologico_sku}-${item.articuloparte_numeroparte}`
                  : item.articulologico_sku}
              </Text>
              {(tiposma === "Orden de Entrega" ||
                tiposma === "Transferencia de Mercadería") &&
                ordenActiva && (
                  <EyeOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      setSkuParaModal(
                        `${item.articulologico_sku}${
                          item.articulologico_ctdpar > 1
                            ? item.articuloparte_numeroparte
                            : ""
                        }`,
                      );

                      setModalStockVisible(true);
                    }}
                    style={{ fontSize: 21, color: "#000" }}
                    className="custom-icon"
                  />
                )}
            </div>
          </Col>
          <Col>
            <Text strong style={{ fontSize: 20, color: "#000" }}>
              {item.etiqueta}
            </Text>
          </Col>
        </Row>

        {/* FILA 2 */}
        <Row style={{ marginTop: 8 }} wrap={false} align="middle">
          <Col flex="auto">
            <Text style={{ display: "block", color: "#000" }}>
              {item.articulologico_nombre}
            </Text>
            <Text strong style={{ display: "block", color: "#000" }}>
              {item?.valcar}
            </Text>
            <Text style={{ display: "block", color: "#000" }}>
              {item.articulologico_modelo}
            </Text>
          </Col>

          <Col>
            <Avatar
              src="/assets/producto.png"
              size={60}
              style={{ backgroundColor: "#8f9ee0" }}
            />
          </Col>
        </Row>

        {/* FILA 3 */}
        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col>
            {ordenActiva && item.confirmada >= 1 && usaModoLote !== "true" && (
              <Image
                src="/icons/keyboard.png"
                className="custom-icon"
                preview={false}
                style={{ width: 36, cursor: "pointer" }}
                onClick={() => {
                  onOpenCantidadModal({
                    ...item,
                    sku: item.articulologico_sku,
                    nombre: item.articulologico_nombre,
                    modelo: item.articulologico_modelo,
                    ubicacion: item.ubicacion_id,
                    etique: item.etiqueta,
                    cantidad: item.cantidad,
                    valorInicial: item.confirmada,
                  });
                }}
              />
            )}

            {usaModoLote === "true" && ordenActiva && (
              <Image
                src="/icons/keyboard.png"
                className="custom-icon"
                preview={false}
                style={{ width: 36, cursor: "pointer" }}
                onMouseDown={() => {
                  holdTimeoutRef.current = setTimeout(() => {
                    onOpenCantidadModal({
                      ...item,
                      sku: item.articulologico_sku,
                      nombre: item.articulologico_nombre,
                      modelo: item.articulologico_modelo,
                      ubicacion: item.ubicacion_id,
                      etique: item.etiqueta,
                      cantidad: item.cantidad,
                      valorInicial: item.confirmada,
                    });
                  }, 500);
                }}
                onMouseUp={() => {
                  clearTimeout(holdTimeoutRef.current);
                }}
                onMouseLeave={() => {
                  clearTimeout(holdTimeoutRef.current);
                }}
              />
            )}
          </Col>

          <Col>
            <Text strong style={{ fontSize: 20, color: "#000" }}>
              {Math.round(item.confirmada)} de {Math.round(item.cantidad)}
            </Text>
          </Col>
        </Row>
      </Card>
      {modalStockVisible && (
        <ModalStock
          open={modalStockVisible}
          onClose={() => setModalStockVisible(false)}
          sku={skuParaModal}
          darkMode={darkMode}
        />
      )}
    </>
  );
};

export default ArticuloCard;
